import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';

import '@shoelace-style/shoelace/dist/components/spinner/spinner.js';
import '@shoelace-style/shoelace/dist/components/icon/icon.js';
import '@shoelace-style/shoelace/dist/components/divider/divider.js';
import '@shoelace-style/shoelace/dist/components/button/button.js';
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js';

import { ViewBase } from '../view-base.js';
import { tutorialIndexViewStyles } from './tutorial-index-view-styles.js';

import { Q1SpinnerPanel } from '../../components/q1-spinner-panel/q1-spinner-panel.js';

export class TutorialIndexView extends ViewBase {
  static styles = [
    ...super.styles,
    tutorialIndexViewStyles,
  ];

  static properties = {
    ...super.properties,

    loading: { type: Boolean },
    
    tutorialManager: { type: Object },
    allTutorialsBySection: { type: Array },
    allTutorialsByKey: { type: Object },
  };

  constructor() {
    super();

    this.loading = true;
    
    this.tutorialManager = null;
    this.allTutorialsBySection = [];
  }

  connectedCallback() {
    super.connectedCallback();

    this.setViewMeta();

    this.tutorialManager = document.querySelector('q1-home').tutorialManager;
    this.tutorialManager.loadingComplete.then(() => {
      this.allTutorialsBySection = this.tutorialManager.allTutorialsBySection;
      this.loading = false;
    }).catch((error) => {
      console.log('Error loading tutorials:', error);
      this.loading = false;
    });
  }

  get contentTemplate() {
    return html`
      <header-bar class="with-border">
        <h1>
          <span class="prefix">q1 Network:</span>
          Member Tutorials
        </h1>
        
        <sl-icon class="header-icon" library="material" name="info"></sl-icon>
      </header-bar>

      ${this.allTutorialsBySection.map(section => html`
        <table class="q1">
          <thead>
            <tr>
              <th colspan="4">${section.title}</th>
            </tr>
          </thead>
          <tbody>
            ${section.tutorials.map(tutorial => html`
              <tr class=${classMap({
                completed: tutorial.isCompleted,
                updated: tutorial.isUpdatedSinceCompletion,
              })}>
                <td class="icon-col">
                  <sl-tooltip content=${tutorial.statusMessage}>
                    <sl-icon library="material" name=${tutorial.statusIcon}></sl-icon>
                  </sl-tooltip>
                </td>
                <td class="title-col">
                  <div class="td-inner">
                    <a href=${`/tutorials/${tutorial.key}`}>${tutorial.title}</a>
                    <span class="divider">—</span>
                    <sl-tooltip content="Estimated Reading Time">
                      <sl-icon library="material" name="schedule"></sl-icon>
                    </sl-tooltip>
                    <span class="duration">${tutorial.readingTime}</span>
                  </div>
                </td>
                <td class="version-col">
                  <small>${tutorial.versionPublishDateString} (v${tutorial.version})</small>
                </td>
                <td class="action-col">
                  <sl-button
                    href=${`/tutorials/${tutorial.key}`}
                    size="small"
                  >View</sl-button>
                </td>
              </tr>
            `)}
          </tbody>
        </table>
      `)}

      <q1-spinner-panel label="Loading" ?open=${this.loading}></q1-spinner-panel>
    `;
  }
}

customElements.define('tutorial-index-view', TutorialIndexView);